import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AccountService } from 'src/app/shared/account.service';
import { TrackingService } from './core/api/tracking.service';
import { CanactivateviaadminService } from './core/guards/canactivateviaadmin.service';
import { CanactivateadminsuperadminService } from './core/guards/canactivateviaadminsuperadmin.service';
import { CanactivateviacustomerService } from './core/guards/canactivateviacustomer.service';
import { CanactivateviacustomeradminService } from './core/guards/canactivateviacustomeradmin.service';
import { CanactivateviadropshippingadminService } from './core/guards/canactivateviadropshippingadmin.service';
import { CanactivateviasalesService } from './core/guards/canactivateviasales.service';
import { CanactivateviasuperadminService } from './core/guards/canactivateviasuperadmin.service';
import { EcwidAuth } from './ecwid/auth/auth.component';
import { Layout } from './layouts/admin-layout/layout.component';
import { UserLayoutComponent } from './layouts/user-layout/user-layout.component';
import { VisitorLayoutComponent } from './layouts/visitor-layout/visitor-layout.component';
import { TrackingModule } from './modules/public/tracking/tracking.module';
import { USER_ROUTES } from './routes/user-layout-routes';
import { VISITOR_ROUTES } from './routes/visitor-layout-routes';
import { shopifylogin } from './shopify/shopifylogin/shopifylogin.component';
import { CanactivateAgentService } from './core/guards/canactivate-agent.service';
import { CanactivateWarehouseAdminService } from './core/guards/canactivate-warehouseAdmin.service';


const routes: Routes = [


  { path: '', component: VisitorLayoutComponent, children: VISITOR_ROUTES },
  { path: 'track', component: VisitorLayoutComponent, children: TrackingModule.routes },
  { path: 'app/track/:trackingNumber', component: VisitorLayoutComponent, children: TrackingModule.routes },
  { path: 'app', component: UserLayoutComponent, children: USER_ROUTES },
  {
    path: 'admin', canActivate: [CanactivateadminsuperadminService], loadChildren: () => import('./layouts/admin-layout/layout.module').then(m => m.LayoutModule)
  },
  {
    path: 'connectshopify', loadChildren: () => import('./modules/user/shops/shoptutorials/shoptutorial.module').then(m => m.ShopTutorialModule),
  },
  // {
  //   path: 'resetpwd', loadChildren: './resetpwd/resetpwd.module#ResetPwdModule'
  //   },
  // {
  //   path: 'register', loadChildren: './register/register.module#RegisterModule'
  // },

  // {
  //   path: 'confirmRegistration', loadChildren: './confirmregistration/confirmregister.module#ConfirmRegisterModule'
  // },
  {
    path: 'prestashopregister/:token/:domain/:domainprefix/:email/:emailprefix',
    loadChildren: () => import('./prestashop/prestashopregister/prestashopregister.module').then(m => m.PrestashopRegisterModule),
  },
  {
    path: 'shopifylogin/:shop/:token', component: shopifylogin
  },
  {
    path: 'shopifyregister/:shop/:token', loadChildren: () => import('./shopify/shopifyregister/shopifyregister.module').then(m => m.ShopifyRegisterModule),
  },
  //  {
  //    //meeeeeeeeeeeeeeeeeeee to be verified
  //  path: 'shippingcalculator', loadChildren: './shippingcalculator/shippingcalculator.module#shippingcalculator'
  //  },
  {
    path: 'maskshippingcalculator', loadChildren: () => import('./modules/admin/masksshippingcalculator/masksshippingcalculator.module').then(m => m.maskshippingcalculator),
  },
  {
    path: 'ecwid/login', component: EcwidAuth
  },
  {
    path: 'installEcwid', loadChildren: () => import('./ecwid/tutorial/tutorial.module').then(m => m.TutorialModule),
  },
  {
    path: 'ecwid/register', loadChildren: () => import('./ecwid/register/ecwidregister.module').then(m => m.EcwidRegisterModule),
  },
  {
    path: 'ecwid/alerte', loadChildren: () => import('./ecwid/exception/exception.module').then(m => m.ExceptionModule),
  },
  {
    path: 'login', redirectTo: '', pathMatch: 'full'
  },

  { path: '**', redirectTo: '404' },

  {
    path: 'agent', canActivate:[CanactivateAgentService], loadChildren: () => import('./modules/agent/agent.module').then(m => m.AgentModule)
  },
  {
    path: 'warehouseManagement', canActivate:[CanactivateWarehouseAdminService], loadChildren: () => import('./modules/warehouseAdmin/warehouse-admin.module').then(m => m.WarehouseAdminModule)
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  // providers: [CanactivateviacustomerService,AccountService],
  providers: [
    CanactivateviacustomeradminService,
    CanactivateviacustomerService,
    CanactivateviaadminService,
    CanactivateviasuperadminService,
    CanactivateadminsuperadminService,
    CanactivateviadropshippingadminService,
    AccountService,
    CanactivateviasalesService,
    TrackingService,
    CanactivateAgentService,
    CanactivateWarehouseAdminService

  ],

})
export class AppRoutingModule { }

